module.exports = __webpack_public_path__ + "static/img/companyyewujingli.d116eb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/companyyewujingli.jpg
// module id = aQ4y
// module chunks = 1